import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GoalsFilterQueryVariables = Types.Exact<{
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  filters?: Types.InputMaybe<Types.GoalsFilters>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
}>;


export type GoalsFilterQuery = { goals: { totalCount: number, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, name: string } }> | null } };


export const GoalsFilterDocument = /*#__PURE__*/ gql`
    query goalsFilter($sort: [SortType!], $filters: GoalsFilters, $after: String, $first: Float) {
  goals(filters: $filters, sort: $sort, first: $first, after: $after) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

export function useGoalsFilterQuery(options?: Omit<Urql.UseQueryArgs<GoalsFilterQueryVariables>, 'query'>) {
  return Urql.useQuery<GoalsFilterQuery, GoalsFilterQueryVariables>({ query: GoalsFilterDocument, ...options });
};